<template>
  <div class="label-container">
    <div class="button-container">
      <el-button type="primary" class="feature-secondary" @click="printPdf()">
        <svg-icon
          icon-class="info"
          class="svg-white-color"
          style="font-size: 18px;"
        />
        Print Label
      </el-button>
    </div>

    <pallet-label
      class="label"
      :group-name="groupName"
      :short-container-no="shortContainerNo"
      :container-no="containerNo"
      :pallet-no="palletNo"
      :src="src"
    >
    </pallet-label>
  </div>
</template>

<script>
// apis
import { queryPallets } from '@/api/pallet'
import { queryOrders } from '@/api/order'
import { queryContainers } from '@/api/container'
// utils
import { downloadPdf } from '@/core/utils/pdf'
// components
import PalletLabel from '@/components/pallet/PalletLabel'
// models
// import { JobTypes } from '@/core/models/job'

const QRCode = require('qrcode')

export default {
  name: 'PalletLabelPage',
  components: { PalletLabel },
  data() {
    return {
      src: '',
      groupName: '',
      shortContainerNo: '',
      containerNo: '',
      palletId: '',
      palletNo: ''
    }
  },
  methods: {
    async getSrc() {
      const src = await QRCode.toDataURL(
        JSON.stringify({
          type: 'pallet',
          palletId: this.palletId,
          palletNo: this.palletNo
        }),
        {
          margin: 0,
          width: 170,
          height: 170
        }
      )
      this.src = src
    },
    async printPdf() {
      const pdf = await this.getPdf('.label', 'label', 'p')
      downloadPdf(pdf, 'pallet_label')
    },
    async getPalletDetail() {
      const palletList = await queryPallets({ nos: this.$route.params.no })
      const palletDetail = palletList[0]
      this.groupName = palletDetail.groupName
      const orderId = palletDetail.orderId
      const ordeList = await queryOrders({ ids: [orderId] })
      const order = ordeList[0]
      const containerId = order.containerId
      this.containerNo = order.containerNo
      const containerList = await queryContainers({ ids: [containerId] })
      const container = containerList[0]
      this.shortContainerNo = container.no
      this.palletId = palletDetail.id
      this.palletNo = palletDetail.no
      this.getSrc()
    }
  },
  mounted() {
    this.getPalletDetail()
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.label-container {
  margin: 10px 20px;
  line-height: 1;

  @extend .f-c;

  gap: 10px;
  color: #000;
}
</style>
